import { UserProfile, RegionalRestriction } from '../types';

export const COUNTRIES = [
  "España", "México", "Argentina", "Chile", "Colombia", "Perú", "Ecuador", 
  "Bolivia", "Uruguay", "Paraguay", "Venezuela", "Costa Rica", "Panamá", 
  "Guatemala", "Honduras", "El Salvador", "Nicaragua", "República Dominicana", "Otros"
];

export const COUNTRY_TO_CONTINENT: Record<string, string> = {
  'argentina': 'Sudamérica', 'colombia': 'Sudamérica', 'peru': 'Sudamérica', 'perú': 'Sudamérica',
  'chile': 'Sudamérica', 'ecuador': 'Sudamérica', 'venezuela': 'Sudamérica', 'bolivia': 'Sudamérica',
  'paraguay': 'Sudamérica', 'uruguay': 'Sudamérica', 'brasil': 'Sudamérica', 'brazil': 'Sudamérica',
  'mexico': 'Norteamérica', 'méxico': 'Norteamérica', 'usa': 'Norteamérica', 'estados unidos': 'Norteamérica',
  'united states': 'Norteamérica', 'canada': 'Norteamérica', 'canadá': 'Norteamérica',
  'espania': 'Europa', 'españa': 'Europa', 'spain': 'Europa', 'italia': 'Europa', 'italy': 'Europa',
  'francia': 'Europa', 'france': 'Europa', 'alemania': 'Europa', 'germany': 'Europa', 'uk': 'Europa',
  'reino unido': 'Europa', 'united kingdom': 'Europa', 'portugal': 'Europa'
};

export const getNormalizedContinent = (countryName: string): string => {
  const norm = (countryName || '').toLowerCase().trim();
  return COUNTRY_TO_CONTINENT[norm] || '';
};

export interface RegionalAccessResult {
  disabledModules: string[];
  renameConclusionToSummary: boolean;
  disableDiferenciales: boolean;
}

// isAdminOverride: pásalo ya calculado por cada pantalla (Master / co-admin exentos de restricciones)
export const getRegionalAccess = (
  userProfile: UserProfile | null | undefined,
  regionalRestrictions: RegionalRestriction[] | any[],
  isAdminOverride: boolean
): RegionalAccessResult => {
  const empty: RegionalAccessResult = { disabledModules: [], renameConclusionToSummary: false, disableDiferenciales: false };
  if (!userProfile || isAdminOverride) return empty;

  const userCountryNorm = (userProfile.workCountry || userProfile.country || '').toLowerCase().trim();
  const userContinentNorm = getNormalizedContinent(userCountryNorm).toLowerCase();

  const disabledSet = new Set<string>();
  let renameConclusionToSummary = false;
  let disableDiferenciales = false;

  (regionalRestrictions || []).forEach((rule: any) => {
    const ruleValNorm = (rule.value || '').toLowerCase().trim();
    let isMatch = false;
    if (rule.type === 'COUNTRY') {
      if (userCountryNorm && (userCountryNorm === ruleValNorm || userCountryNorm.includes(ruleValNorm) || ruleValNorm.includes(userCountryNorm))) {
        isMatch = true;
      }
    } else if (rule.type === 'CONTINENT') {
      if (userContinentNorm && (userContinentNorm === ruleValNorm || userContinentNorm.includes(ruleValNorm) || ruleValNorm.includes(userContinentNorm))) {
        isMatch = true;
      }
    }
    if (isMatch) {
      (rule.disabledModules || []).forEach((m: string) => disabledSet.add(m));
      if (rule.renameConclusionToSummary) renameConclusionToSummary = true;
      if (rule.disableDiferenciales) disableDiferenciales = true;
    }
  });

  return { disabledModules: Array.from(disabledSet), renameConclusionToSummary, disableDiferenciales };
};
